import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getCategoryAction } from '../../redux/toolkit/category/getCategory'
import PropTypes from 'prop-types';
import { deleteBannerAction } from '../../redux/toolkit/banner/deleteBanner'
import { getBannerAction } from '../../redux/toolkit/banner/getBanner'


export default function DeleteBanner({ banner_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const deleteBanner = useSelector(state => state.deleteBanner)
    const { status, message,loading } = deleteBanner

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        console.log("hello world")
        setState(false)
        await dispatch(deleteBannerAction(banner_id))
        console.log("message----",message);
        setSnack(true)
        await dispatch(getBannerAction({ is_deleted: false }))
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>

            {console.log("message befor snackbar ui-->",message)}
            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
            
        </>

    )
}



DeleteBanner.propTypes = {
    cat_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};
